module.exports = __webpack_public_path__ + "d0af20605a3ec70e651f7f9e06157995.svg";